'use strict';

export const LOGIN_SUCCESS = 'users/LOGIN_SUCCESS';
export const LOGOUT = 'users/LOGOUT';
export const SET_LOGGED_IN_USER = 'users/SET_LOGGED_IN_USER';
export const SEARCH_USERS = 'users/SEARCH_USERS';
export const FETCH_USER = 'users/FETCH_USER';
export const FETCH_USER_COMPLETED = 'users/FETCH_USER_COMPLETED';
export const GET_USERS = 'users/GET_USERS';
export const GET_USERS_COMPLETED = 'users/GET_USERS_COMPLETED';
export const POST_CREATE_USER = 'users/POST_CREATE_USER';
export const POST_CREATE_USER_COMPLETED = 'users/POST_CREATE_USER_COMPLETED';
export const POST_UPDATE_USER = 'users/POST_UPDATE_USER';
export const POST_UPDATE_USER_COMPLETED = 'users/POST_UPDATE_USER_COMPLETED';
export const POST_SETTINGS = 'users/POST_SETTINGS';
export const POST_SETTINGS_COMPLETED = 'users/POST_SETTINGS_COMPLETED';
export const CHANGE_PASSPHRASE = 'users/CHANGE_PASSPHRASE';
export const CHANGE_PASSPHRASE_COMPLETED = 'users/CHANGE_PASSPHRASE_COMPLETED';
export const SAVE_UI_SETTING = 'users/SAVE_UI_SETTING';
export const SAVE_UI_SETTING_COMPLETED = 'users/SAVE_UI_SETTING_COMPLETED';
export const DELETE_USER = 'users/DELETE_USER';
export const DELETE_USER_COMPLETED = 'users/DELETE_USER_COMPLETED';
